import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=2b387858&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"
import style0 from "./Model.vue?vue&type=style&index=0&id=2b387858&prod&lang=less"
import style1 from "./Model.vue?vue&type=style&index=1&id=2b387858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b387858",
  null
  
)

export default component.exports